
export default {
  props: {
    to: {
      type: String,
      required: true
    },
    prompt: {
      type: String,
      default: ''
    }
  }
}
